let navigationMixin = {
    methods: {
        navigateTo (name, props, query) {
            let routeObj = {
                name: name,
            };
            if (props) {
                routeObj.params = props;
            }
            if (query) {
                routeObj.query = query;
            }
            this.$router.push(routeObj).catch(e => { console.log(e)});
        }
    }
};

export { navigationMixin };